import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getEstimationClassList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  const firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const EstimationClass = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  type,
  disabled,
  dropView,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [fetchResponse, setFetchResponse] = useState([])

  const loadOptions = async () => {
    setIsLoading(true)
    const data = await getEstimationClassList(type)
    setIsLoading(false)
    const response = data?.data?.map(dta => ({
      label:
        dta?.class_code && ucfirst(`${dta.class_code}-${dta?.description}`),
      value: dta.id,
      ...dta,
    }))
    setFetchResponse(response)
  }

  // Load options when the component mounts or when `type` changes
  useEffect(() => {
    loadOptions()
  }, [type]) // Add `type` as a dependency

  return (
    <div>
      <Controller
        name={name}
        control={control}
        defaultValue={null} // Ensure a default value is set
        render={({
          field: { onChange, ref, value },
          fieldState: { invalid },
        }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              invalid={invalid}
              onChange={e => {
                onChange(e) // Update react-hook-form value
                if (onSelectChange) onSelectChange(e) // Call custom callback
              }}
              isDisabled={disabled ? true : false}
              value={
                value
                  ? value
                  : fetchResponse.find(option => option.value === value)
              } // Ensure value is stable
              classNamePrefix="react-select"
              className="elevate-dropdown"
              // menuPortalTarget={document.querySelector(
              //   target ? target : ".modal"
              // )}
              menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              menuPlacement={dropView ? "top" : "bottom"}
            />
          )
        }}
      />
    </div>
  )
}

export default EstimationClass
